export enum DataSyncModalAction {
  ARCHIVE_DESTINATION = 'archiveDestination',
}

export type DataSyncModalState = {
  action: DataSyncModalAction;
  payload?: {
    destinationId?: string;
    destinationName?: string;
  };
};
